export default "__VITE_ASSET__Y_81NXcw__"